'use client';

import React from 'react';
import { useTranslations } from 'next-intl';

export interface ProductPriceProps {
  price: string;
  // The US shop shows net prices, so the VAT note is suppressed there.
  isVatNoteHidden: boolean;
}

export function ProductPrice({ price, isVatNoteHidden }: Readonly<ProductPriceProps>) {
  const t = useTranslations('ProductChooser');

  return (
    <p className="flex flex-wrap items-baseline gap-2">
      <span className="text-3xl font-bold text-neutral-100">{price}</span>
      {!isVatNoteHidden && (
        <span className="text-sm font-normal text-neutral-55">{t('incl VAT')}</span>
      )}
    </p>
  );
}
